import React from "react";
import classNames from "classnames";
import { PhoneInputProps } from "./types";
import styles from "./phone-input.module.scss";

export const PhoneInput = ({
    value = "7",
    onChange,
    className,
    placeholder = "+7 (999) 123 45 67"
}: PhoneInputProps) => {
    const formatPhone = (digits: string) => {
        if (!digits) return "";

        if (!digits.startsWith("7")) return `+${digits}`;

        const body = digits.slice(1);
        let result = "+7";
        if (body.length > 0) result += ` (${body.slice(0, 3)}`;
        if (body.length >= 4) result += `) ${body.slice(3, 6)}`;
        if (body.length >= 7) result += `-${body.slice(6, 8)}`;
        if (body.length >= 9) result += `-${body.slice(8, 10)}`;
        return result;
    };

    const displayValue = value ? formatPhone(value) : "";

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let digits = e.target.value.replace(/\D/g, "");

        if (!digits) {
            onChange("");
            return;
        }

        digits = digits.slice(0, 11);
        onChange(digits);
    };

    return (
        <input
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            className={classNames(styles["phone-input"], className)}
            placeholder={placeholder}
            value={displayValue}
            onChange={handleChange}
        />
    );
};